export default "__VITE_ASSET__Demz2aVa__"